import replaceAdsProductIDs from './utils/replaceAdsProductIDs';
// import replaceProductRankingIDs from './utils/replaceProductRankingIDs';
import replaceProductIDs from './utils/replaceProductIDs';
import replaceCollectionIds from './utils/replaceCollectionIds';
// import replaceListProductIDs from './utils/replaceListProductIDs';
import replaceTOC from './utils/replaceTOC';

export const parseContent = (content, pageContext) => {
  if (!content || !pageContext) {
    return null;
  }



  return content
    .replace(/(?:{{\s*ad:\s*([^\s}]+)\s*}}|<p>{{\s*ad:\s*([^\s}]+)\s*}}<\/p>)/g, replaceAdsProductIDs.bind(this, pageContext.ads))
    // .replace(/(?:{{\s*productRanking:\s*([^\s}]+)\s*}}|<p>{{\s*ad:\s*([^\s}]+)\s*}}<\/p>)/g, replaceProductRankingIDs.bind(this, pageContext.productRanking))
    .replace(/{{\s*product:\s*([^\s]+)\s*}}/g, replaceProductIDs.bind(this, pageContext.products))
    .replace(/{{\s*collection:\s*([^\s]+)\s*}}/g, replaceCollectionIds.bind(this, pageContext.collections))
    // .replace(/{{\s*products:\s*([^\s]+)\s*}}/g, replaceListProductIDs.bind(this, pageContext.productLists))
    .replace(/{{\s*toc\s*}}/g, replaceTOC.bind(this, pageContext.tocLinks));
};
